<script lang="ts">
  import { scale } from "svelte/transition"
  import Dropdown from "$app/components/Dropdown.svelte"
  import { ChevronDown, ChevronRight } from "lucide-svelte"

  interface Props {
    options: any
    periods: any
    onupdateGoalsPeriod: (data: any) => void
  }

  let props = $props()
  let { options, periods, onupdateGoalsPeriod }: Props = props

  let openDropdown = $state(false)

  function updateGoalsPeriod(quarter, year) {
    onupdateGoalsPeriod({ quarter: quarter, year: year })
    openDropdown = false
  }
</script>

<Dropdown closeOnOuterClick={true} bind:open={openDropdown}>
  {#snippet button()}
    <button
      type="button"
      class="inline-flex justify-center w-full rounded-sm border border-gray-200 shadow-sm px-4 text-sm py-1 bg-white font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500"
      aria-haspopup="true"
    >
      {#if options.quarter > 0}
        {options.fiscal_year} Q{options.quarter}
      {:else}
        All {options.fiscal_year}
      {/if}
      <ChevronDown class="-mr-1 mt-1 ml-2 h-3 w-3 text-gray-500" />
    </button>
  {/snippet}
  <div
    class="origin-top-right absolute right-0 mt-2 w-40 rounded-md shadow-lg bg-gray-100 ring-1 ring-gray-200 ring-opacity-5 z-10"
    in:scale={{ duration: 100, start: 0.95 }}
    out:scale={{ duration: 75, start: 0.95 }}
  >
    <div
      class="py-1"
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="options-menu"
    >
      {#each Object.entries(periods) as [year, data]}
        <button
          class="px-4 py-2 text-sm font-bold bg-gray-100 border-b border-gray-300 flex justify-between w-full"
          onclick={() => (periods[year].open = !periods[year].open)}
          type="button"
        >
          {data.fiscal_year}
          {#if periods[year].open}
            <ChevronDown class="-mr-1 mt-1 ml-3 h-3 w-3 text-gray-400" />
          {:else}
            <ChevronRight class="-mr-1 mt-1 ml-3 h-3 w-3 text-gray-400" />
          {/if}
        </button>
        {#if periods[year].open}
          <div class="bg-white border-b border-gray-300">
            {#each data.quarters as quarter}
              <button
                onclick={() => updateGoalsPeriod(quarter, year)}
                class="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
              >
                {data.fiscal_year} Q{quarter}
              </button>
            {/each}
            <button
              onclick={() => updateGoalsPeriod(-1, year)}
              class="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
            >
              All {data.fiscal_year}
            </button>
          </div>
        {/if}
      {/each}
    </div>
  </div>
</Dropdown>
